import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import React, { PureComponent } from 'react';
import { Route } from 'react-router';
import { LayoutWithRouter } from './Layout';
import ApiAuthorizationRoutes from '../api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from '../api-authorization/ApiAuthorizationConstants';

import './App.css'

export default class App extends PureComponent {
  static displayName = App.name;

  render () {
    return (
      <LayoutWithRouter>
        <Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />
      </LayoutWithRouter>
    );
  }
}